import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    marginLeft: theme.spacing(14),
    display: 'flex',
    flexDirection: 'row',
  },
  label: {
    color: theme.palette.getContrastText(theme.palette.common.black),
  },
  left: {
    flex: 1,
    width: '100%',
  },
  right: {
    display: 'flex',
    width: 150,
    justifyContent: 'space-around',
  },
}));

const AppBarControls = props => {
  const classes = useStyles();

  return <div className={classes.root}></div>;
};
export default AppBarControls;
